module.exports = __webpack_public_path__ + "assets/pie_israel-6a105c.svg";